import axios from 'axios'

const generatePchSaleBookExcel =  async function(id){
    try{
        const   path = `/acc_purchase_sale_book/${id}/excel`
            ,   route = process.env.VUE_APP_API_ROUTE.concat( path )
            let response = await axios({
                url: route,
                method: 'GET',
                responseType: 'blob',
            })
            return response
    }
    catch( error ) {
        return error.response
    }
}

export { generatePchSaleBookExcel }
